// src/utils/wechatAuth.js
/**
 * 微信授权工具类
 */

/**
 * 检查是否在微信环境中
 * @returns {boolean}
 */
export function isWechat() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger');
}

/**
 * 获取 URL 参数
 * @param {string} name 参数名
 * @returns {string|null} 参数值
 */
export function getUrlParam(name) {
  // 先尝试从 search 中获取
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);

  // 再尝试从 hash 中获取（Vue Router hash 模式）
  const hash = window.location.hash;
  if (hash) {
    const hashReg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const hashR = hash.substr(1).match(hashReg);
    if (hashR != null) return decodeURIComponent(hashR[2]);
  }

  return null;
}

/**
 * 重定向到微信授权页面
 * @param {string} appId 微信公众号 AppID
 * @param {string} redirectUri 回调地址
 * @param {string} agentId 代理人ID（可选）
 */
export function redirectToWechatAuth(appId, redirectUri, agentId = null) {
  console.log('重定向到微信授权页面:', redirectUri);
  // 如果提供了 agentId，将其添加到 redirectUri 中
  let finalRedirectUri = redirectUri.split('#')[0];
  if (agentId) {
    const separator = finalRedirectUri.includes('?') ? '&' : '?';
    finalRedirectUri = `${finalRedirectUri}${separator}agent=${agentId}`;
  }
  const encodedUrl = encodeURIComponent(finalRedirectUri);
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodedUrl}&response_type=code&scope=snsapi_base&state=wechat_login#wechat_redirect`;
  window.location.href = authUrl;
}

/**
 * 获取 URL 参数（包括 hash 后的参数）
 * @param {string} name 参数名
 * @returns {string|null} 参数值
 */


/**
 * 获取微信用户信息（需要后端支持）
 * @param {string} code 授权码
 * @returns {Promise<Object>} 用户信息
 */
export async function getWechatUserInfo(code) {
  try {
    const response = await fetch(`/api/wechat/userinfo?code=${code}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('获取微信用户信息失败:', error);
    throw error;
  }
}

/**
 * 微信静默登录主函数
 * @param {string} appId 微信公众号 AppID
 * @param {string} agentId 代理人ID（可选）
 * @returns {Promise<Object|null>} 用户信息或 null
 */
export async function wechatSilentLogin(appId, agentId = null) {
  // 检查是否有 code 参数
  const code = getUrlParam('code');
  if (!code) {
    // 没有 code，重定向到微信授权页面
    const redirectUri = window.location.href;
    redirectToWechatAuth(appId, redirectUri, agentId);
    return null;
  }

  // 有 code，获取用户信息
  try {
    const result = await getWechatUserInfo(code);
    if (result.success) {
      // 保存 agentId 到 localStorage（如果存在）
      const urlAgentId = getUrlParam('agent');
      if (urlAgentId) {
        localStorage.setItem('agentId', urlAgentId);
      }
      return result.user;
    } else {
      throw new Error(result.error || '获取用户信息失败');
    }
  } catch (error) {
    console.error('微信登录失败:', error);
    return null;
  }
}

export default {
  isWechat,
  getUrlParam,
  redirectToWechatAuth,
  getWechatUserInfo,
  wechatSilentLogin
};
